import { Helmet } from "react-helmet-async";

const SITE_NAME = "Barrhaven Beauty Lounge";
const DEFAULT_TITLE =
  "Barrhaven Beauty Lounge | Facials, Laser & Skincare in Nepean, ON";
const DEFAULT_DESC =
  "Barrhaven Beauty Lounge is a refined beauty studio in Nepean, Ottawa offering custom facials, laser hair removal, waxing, threading and advanced Korean skincare — personalised care in a calm, elegant space.";

export default function Seo({
  title,
  description,
  path = "",
  image = "/og-image.jpg",
  type = "website",
  noindex = false,
}) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}${path}`;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const img = image.startsWith("http") ? image : `${origin}${image}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="en_CA" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
